/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProfile } from "../../Components/Hooks/UserHooks";
import {
  createRoute,
  deleteRoute,
  listDriver,
  listRoute,
  listStore,
  updateRoute,
  listSlotType,
  upsertLocation
} from "./_requests";
import {RouteAreaMap} from "./RouteAreaMap";
const Route = (data: any) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [Route, setRoute] = useState<any>([]);
  const [Store, setStore] = useState<any>([]);
  const [Routeaccess, setRouteaccess] = useState<any>([]);
  const { userProfile } = useProfile();
  const [modal, setModal] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [RouteToDeleteId, setRouteToDeleteId] = useState<string>("");
  const [RouteToDeleteName, setRouteToDeleteName] = useState<string>("");
  const [Duplicate, setDuplicate] = useState<any>("");
  const [ordersListDriver, setDriver] = useState<any>([]);
  const [changeSlot, setChangeSlot] = useState(false);
  const [changeDriver, setChangeDriver] = useState(false);
  const [slotTypes, setSlotTypes] = useState<any>([]);

  const [isCheckingDuplicate, setIsCheckingDuplicate] = useState(false);
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
  console.log("ordersListDriver route indeex state", ordersListDriver)
  //map view
  const [mapModal, setMapModal] = useState(false);
const [selectedArea, setSelectedArea] = useState<any>(null);
const [confirmMapModal, setConfirmMapModal] = useState(false);
const [pendingRoute, setPendingRoute] = useState<any>(null);
const [isMapEdit, setIsMapEdit] = useState(false);
const [isSaving, setIsSaving] = useState(false);
  const toggle = useCallback(() => {
    setModal(!modal);
    setDuplicate("");
  }, [modal]);

  useEffect(() => {
    listStore().then((res: any) => {
      setStore(res.data);
    });
    listDriver().then((res: any) => {
      setDriver(res.data);
    });
    listSlotType().then((res: any) => {
      setSlotTypes(res.data);
    });
  }, []);

  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  useEffect(() => {
    fetchRoute();
  }, []);

  const fetchRoute = () => {
    listRoute().then((res: any) => {
      setRoute(res.data);
    });
  };

  // Delete Data
  const onClickDelete = useCallback(
    (Route: any) => {
      setRouteToDeleteName(Route.name);
      setRouteToDeleteId(Route.id);
      toggleDeleteModal();
    },
    [setRouteToDeleteName, setRouteToDeleteId, toggleDeleteModal]
  );
//map
  const openMapView = (route: any) => {
  if (!route?.DeliveryLocations[0]?.coordinates || route?.DeliveryLocations[0]?.coordinates.length === 0) {
    toast.error("No area defined for this route");
    return;
  }

  setSelectedArea(route?.DeliveryLocations[0]);
  setMapModal(true);
};
console.log("RAW COORDINATES", pendingRoute?.DeliveryLocations[0]?.coordinates);
  // validation
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      name: "",
      store_id: "",
      slot_type: "",
      delivery_time_min: "",
      delivery_time_max: "",
      driver_id: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Name is required")
        .matches(/^[A-Za-z0-9\-\/\\\s]+$/, "Only alphanumeric and -/\\ characters allowed"),
      store_id: Yup.string().required("Store is required"),
      slot_type: Yup.string().required("Slot is required, Please assign atleast one Slot"),
      driver_id: Yup.string().required("Driver is required, Please assign atleast one"),
    }),
    onSubmit: async (values: any) => {
      try {
        // Check for duplicate route name (case insensitive)
        const isDuplicate = Route.some(
          (route: any) => route.name.toLowerCase() === values.name.toLowerCase() &&
            (!isEdit || route.id !== values.id)
        );

        if (isDuplicate) {
          toast.error("Route name already exists", { autoClose: 3000 });
          return;
        }

        const userId = userProfile.userId;
        const data = {
          name: values.name,
          store_id: values.store_id,
          driver_id: values.driver_id,
          slot_type: values.slot_type,
          delivery_time_min: values.delivery_time_min,
          delivery_time_max: values.delivery_time_max,
          ...(isEdit ? { updated_by: userId } : { created_by: userId }),
        };

        const actionPromise = isEdit
          ? updateRoute(data, values.id)
          : createRoute(data);

        actionPromise
          .then((res: any) => {
            toast.success(res.message, { autoClose: 3000 });
            fetchRoute();
            validation.resetForm();
            toggle();
          })
          .catch((error: any) => {
            console.error("Error:", error);
            toast.error("Something went wrong", { autoClose: 3000 });
          });
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong", { autoClose: 3000 });
      }
    },
  });

  const confirmDelete = async (RouteId: any) => {
    await deleteRoute(RouteId, userProfile?.userId);
    toggleDeleteModal();
    toast.success("Route deleted Successfully", { autoClose: 3000 });
    fetchRoute();
  };

  const handleRouteClick = useCallback(
    (Route: any) => {
      validation.setValues({
        id: Route.id,
        name: Route.name,
        store_id: Route.store.id,
        driver_id: Route.driver_id || "",
        slot_type: Route.slot_type || "",
        delivery_time_min: Route.delivery_time_min || "",
        delivery_time_max: Route.delivery_time_max || "",
      });
      setIsEdit(true);
      toggle();
    },
    [toggle, validation]
  );

  const handleSaveLocation = async (mapData: any) => {
    if (!pendingRoute || !mapData) return;

    try {
      setIsSaving(true);
      const data = {
        route_id: pendingRoute.id,
        type: mapData.type,
        coordinates: mapData.coordinates,
        radius: mapData.radius || 0,
        name: pendingRoute.name + " Area",
        user_id: userProfile.userId
      };

      const res: any = await upsertLocation(data);
      if (res.status) {
        toast.success(res.message || "Location updated successfully");
        fetchRoute();
        setMapModal(false);
        setIsMapEdit(false);
        setPendingRoute(null);
      } else {
        toast.error(res.message || "Failed to update location");
      }
    } catch (error) {
      console.error("Error saving location:", error);
      toast.error("An error occurred while saving the location");
    } finally {
      setIsSaving(false);
    }
  };
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: "Store",
        accessorKey: "store.name",
        enableColumnFilter: false,
      },
      {
        header: () => <span className="font-bold">Slot</span>, // Bold header
        accessorKey: "slot_type_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: <T = unknown>() => T }) => {
          const slotTypeName = getValue<string>();
          return (
            <span className="text-primary fw-bold">
              {slotTypeName.split(',').map((type, index) => (
                <span key={index}>
                  {index > 0 && ", "}
                  {type || "-"}
                </span>
              ))}
            </span>
          );
        }
      },
      {
        header: "Drivers",
        accessorKey: "driver_names",
        enableColumnFilter: false,
        cell: (cell: any) => {
          // Handle empty/null values and show "-" when no drivers
          const driverNames = cell.getValue()?.trim();
          if (!driverNames) {
            return <span className="text-muted">-</span>;
          }

          const driverList = driverNames.split(",").map((p: string) => p.trim()).filter(Boolean);
          const rowId = cell.row.id || cell.row.index;
          const expanded = expandedRows[rowId] || false;
          const toggleExpanded = () => setExpandedRows(prev => ({ ...prev, [rowId]: !prev[rowId] }));

          const visibleBadges = expanded ? driverList : driverList.slice(0, 3);
          const remainingCount = driverList.length - 3;

          return (
            <div className="d-flex flex-wrap gap-1">
              {visibleBadges.map((item: string, index: number) => (
                <span key={index} className="badge bg-primary text-white fs-8">
                  {item}
                </span>
              ))}
              {remainingCount > 0 && (
                <span
                  className="badge bg-secondary text-white cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={toggleExpanded}
                >
                  {expanded ? "Show less" : `+${remainingCount}`}
                </span>
              )}
            </div>
          );
        },
      },


      {
        header: "Action",
        cell: (cellProps: any) => {
          const RouteData = cellProps.row.original;
          const hasOrders = RouteData.orderCount > 0;
          console.log("RouteData======",RouteData);
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title="View Area">
  <Link
    to="#"
    className="text-success d-inline-block"
    onClick={() => {console.log("RouteData======",RouteData?.DeliveryLocations[0]?.coordinates);
      if (!RouteData?.DeliveryLocations[0]?.coordinates || RouteData?.DeliveryLocations[0]?.coordinates.length === 0) {
        toast.error("No area defined for this route");
        return;
      }

      // Store route temporarily
      setPendingRoute(RouteData);
      setIsMapEdit(false);
      setConfirmMapModal(true);
    }}
  >
    <i className="ri-map-pin-2-fill fs-16"></i>
  </Link>
</li>
<li className="list-inline-item" title="Edit Location">
  <Link
    to="#"
    className="text-warning d-inline-block"
    onClick={() => {
      setPendingRoute(RouteData);
      setIsMapEdit(true);
      setConfirmMapModal(true);
    }}
  >
    <i className="ri-map-pin-user-fill fs-16"></i>
  </Link>
</li>
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to="#"
                  className="text-primary d-inline-block edit-item-btn"
                  onClick={() => {
                    const RouteData = cellProps.row.original;
                    handleRouteClick(RouteData);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>
              <li
                className="list-inline-item"
                title={hasOrders ? `Cannot delete - ${RouteData.orderCount} order(s) exist` : "Remove"}
                data-bs-toggle="tooltip" // Enable Bootstrap tooltip
                data-bs-placement="top"
              >
                {hasOrders ? (
                  <span
                    className="text-danger d-inline-block"
                    style={{
                      cursor: "not-allowed",
                      opacity: 0.5,
                      position: 'relative'
                    }}
                  >
                    <i className="ri-delete-bin-5-fill fs-16"></i>
                    {/* Small badge showing product count */}
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{
                        fontSize: '0.5em',
                        padding: '0.25em 0.4em'
                      }}
                    >
                      {RouteData.orderCount}
                    </span>
                  </span>
                ) : (
                  <Link
                    to="#"
                    className="text-danger d-inline-block remove-item-btn"
                    onClick={() => onClickDelete(RouteData)}
                  >
                    <i className="ri-delete-bin-5-fill fs-16"></i>
                  </Link>
                )}
              </li>
              {/* <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const RouteData = cellProps.row.original;
                    onClickDelete(RouteData);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li> */}
            </ul>
          );
        },
      },
    ],
    [handleRouteClick, onClickDelete, Route]
  );

  const addRoute = () => {
    setIsEdit(false);
    toggle();
    validation.resetForm();
  };

  document.title = " Paal Dappa | Admin panel";
        
  console.log("pendingRoute.coordinates",pendingRoute?.DeliveryLocations[0]?.coordinates);
  return (<>
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Route" pageTitle="Route" />
          <Row>
            <Col lg={12}>
              <Card id="RouteList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">Route List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>
                        <button
                          type="button"
                          className="btn text-white add-btn me-1"
                          style={{
                            backgroundColor: "#28a8df",
                            borderColor: "#28a8df",
                          }}
                          id="create-btn"
                          onClick={addRoute}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add Route
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  <div>
                    <TableContainer
                      columns={columns}
                      data={Route || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-4"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      SearchPlaceholder="Search Route..."
                    />
                  </div>

                  <Modal id="showModal" isOpen={modal} toggle={toggle} centered>
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Route" : "Add Route"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e: any) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />

                        <div className="mb-4">
                          <Label htmlhtmlFor="Routename-field" className="form-label">
                            Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name"
                            id="Routename-field"
                            className="form-control"
                            placeholder="Enter Name"
                            type="text"
                            onChange={(e) => {
                              validation.handleChange(e);
                              // checkForDuplicate(e.target.value);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              (validation.touched.name && validation.errors.name) 
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : (
                            validation.values.name &&
                            validation.values.name.length > 0 &&
                            Route.some(
                              (v: any) =>
                                v.name.trim().toLowerCase() == validation.values.name.trim().toLowerCase() &&
                                (!isEdit || v.id != validation.values.id)
                            ) && (
                              <FormFeedback type="invalid" style={{ display: "block" }}>
                                Route name already exists
                              </FormFeedback>
                            )
                          )}

                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-4">
                          <Label htmlhtmlFor="status-field" className="form-label">
                            Store<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="store_id"
                            type="select"
                            className="form-select"
                            id="status-field"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.store_id || ""}
                            invalid={
                              validation.touched.store_id &&
                                validation.errors.store_id
                                ? true
                                : false
                            }
                          >
                            <option>Select a store...</option>
                            {Store?.map((item: any, index: any) => (
                              <option value={item.id} key={index}>
                                {item.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.store_id &&
                            validation.errors.store_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.store_id}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-4">
                          <Label className="form-label fw-semibold">
                            Available Time Slots<span className="text-danger">*</span>
                          </Label>

                          <div className="row">
                            {slotTypes.map((slot: any, index: number) => (
                              <div className="col-6 mb-2" key={index}>
                                <div className="form-check d-flex align-items-center">
                                  <Input
                                    name="slot_type"
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{ width: "20px", height: "20px" }}
                                    id={`slot-${slot.id}`}
                                    value={slot.id.toString()}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const currentValues = validation.values.slot_type
                                        ? (typeof validation.values.slot_type === 'string'
                                          ? validation.values.slot_type.split(',')
                                          : [])
                                        : [];
                                      const newValues = checked
                                        ? [...currentValues, e.target.value]
                                        : currentValues.filter((val: any) => val !== e.target.value);
                                      validation.setFieldValue('slot_type', newValues.join(','));
                                    }}
                                    checked={
                                      validation.values.slot_type
                                        ? (typeof validation.values.slot_type === 'string'
                                          ? validation.values.slot_type.split(',').includes(slot.id.toString())
                                          : false)
                                        : false
                                    }
                                  />
                                  <Label className="form-check-label ms-2" htmlFor={`slot-${slot.id}`}>
                                    <span className="d-flex align-items-center">
                                      {/* <i className="ri-sun-line me-2 fs-5"></i> */}
                                      <span className="fs-5">{slot.name}</span>
                                    </span>
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </div>


                          {validation.touched.slot_type && validation.errors.slot_type ? (
                            <div className="invalid-feedback d-block mt-2">
                              <i className="ri-error-warning-line me-1"></i>
                              {validation.errors.slot_type}
                            </div>
                          ) : null}
                        </div>

                        <div className="mb-4">
                          <Label htmlhtmlFor="delivery-time-field" className="form-label">
                            Delivery Time Range <span className="text-danger">*</span>
                          </Label>
                          <div className="d-flex align-items-center gap-2">
                            <Input
                              name="delivery_time_min"
                              id="delivery-time-min"
                              className="form-control"
                              placeholder="Min days"
                              type="number"
                              min="0"
                              onChange={(e) => {
                                const min = e.target.value;
                                const max = validation.values.delivery_time_max || min;
                                validation.setFieldValue('delivery_time_min', min);
                                validation.setFieldValue('delivery_time_range',
                                  min === max ? `${min}` : `${min}-${max}`);
                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.delivery_time_min || ""}
                              invalid={
                                validation.touched.delivery_time_min &&
                                  validation.errors.delivery_time_min
                                  ? true
                                  : false
                              }
                            />
                            <span>to</span>
                            <Input
                              name="delivery_time_max"
                              id="delivery-time-max"
                              className="form-control"
                              placeholder="Max days"
                              type="number"
                              min={validation.values.delivery_time_min || "0"}
                              onChange={(e) => {
                                const max = e.target.value;
                                const min = validation.values.delivery_time_min || max;
                                validation.setFieldValue('delivery_time_max', max);
                                validation.setFieldValue('delivery_time_range',
                                  min === max ? `${min}` : `${min}-${max}`);
                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.delivery_time_max || ""}
                              invalid={
                                validation.touched.delivery_time_max &&
                                  validation.errors.delivery_time_max
                                  ? true
                                  : false
                              }
                            />
                            <input
                              type="hidden"
                              name="delivery_time_range"
                              value={validation.values.delivery_time_range || ""}
                            />
                          </div>
                          {validation.touched.delivery_time_min && validation.errors.delivery_time_min ? (
                            <FormFeedback type="invalid">
                              {validation.errors.delivery_time_min}
                            </FormFeedback>
                          ) : null}
                          {validation.touched.delivery_time_max && validation.errors.delivery_time_max ? (
                            <FormFeedback type="invalid">
                              {validation.errors.delivery_time_max}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-4">
                          <Label className="form-label">
                            Driver ({ordersListDriver?.length || 0}) <span className="text-danger">*</span>
                            <span className="ms-2 text-info ">
                              (Selected: {validation.values.driver_id ? validation.values.driver_id.split(',').filter(Boolean).length : 0})
                            </span>
                          </Label>

                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody>
                                {(() => {
                                  const rows = [];
                                  const driversPerRow = 3;
                                  for (let i = 0; i < ordersListDriver?.length; i += driversPerRow) {
                                    const rowDrivers = ordersListDriver.slice(i, i + driversPerRow);
                                    rows.push(
                                      <tr key={i}>
                                        {rowDrivers.map((item: any, index: any) => (
                                          <td key={index}>
                                            <div className="form-check">
                                              <Input
                                                name="driver_id"
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                id={`driver-${item.id}`}
                                                value={item.id}
                                                onChange={(e) => {
                                                  const checked = e.target.checked;
                                                  const currentValues = validation.values.driver_id
                                                    ? validation.values.driver_id.split(',')
                                                    : [];
                                                  const newValues = checked
                                                    ? [...currentValues, e.target.value]
                                                    : currentValues.filter((val: any) => val !== e.target.value);
                                                  validation.setFieldValue('driver_id', newValues.join(','));
                                                }}
                                                checked={validation.values.driver_id?.includes(item.id.toString()) || false}
                                              />
                                              <Label className="form-check-label" htmlFor={`driver-${item.id}`}>
                                                {item.name}
                                              </Label>
                                            </div>
                                          </td>
                                        ))}
                                      </tr>
                                    );
                                  }
                                  return rows;
                                })()}
                              </tbody>
                            </table>
                          </div>

                          {validation.touched.driver_id && validation.errors.driver_id ? (
                            <div className="invalid-feedback d-block">
                              {validation.errors.driver_id}
                            </div>
                          ) : null}
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn text-white add-btn me-1"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                            onClick={() => {
                              setModal(false);
                            }}
                          >
                            Close
                          </button>
                          <button
                            type="submit"
                            className="btn text-white add-btn me-1"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                          // disabled={!validation.isValid || validation.isSubmitting}
                          >
                            {!!isEdit ? "Update" : "Add Route"}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} centered>
            <ModalHeader toggle={toggleDeleteModal}>
              Confirm Deletion
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete the Route{" "}
              <strong>{RouteToDeleteName}</strong>?
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={toggleDeleteModal}
              >
                Cancel
              </Button>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={() => {
                  confirmDelete(RouteToDeleteId);
                  setModal(false);
                }}
              >
                Delete
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
    <Modal isOpen={mapModal} toggle={() => setMapModal(false)} size="lg" centered>
  <ModalHeader toggle={() => setMapModal(false)}>
    Route Area View
  </ModalHeader>

<ModalBody
  style={{
    height: "500px",
    padding: 0,
    display: "flex",
  }}
>
    <div style={{ flex: 1 }}>
      <RouteAreaMap area={selectedArea} isOpen={mapModal} isEdit={isMapEdit} onSave={handleSaveLocation} isSaving={isSaving} />
    </div>
  </ModalBody>
</Modal>
<Modal isOpen={confirmMapModal} toggle={() => setConfirmMapModal(false)} centered>
  <ModalHeader toggle={() => setConfirmMapModal(false)}>
    Open Map View
  </ModalHeader>

  <ModalBody>
    <p className="mb-2">
      {isMapEdit ? "Entering map edit mode will use Google Maps API and may increase usage cost." : "Viewing the map will use Google Maps API and may increase usage cost."}
    </p>
    <p className="fw-semibold">
      Do you want to continue?
    </p>
  </ModalBody>

  <ModalFooter>
    <Button
      className="btn btn-secondary"
      onClick={() => {
        setConfirmMapModal(false);
        setPendingRoute(null);
      }}
    >
      Cancel
    </Button>

    <Button
      className="btn text-white"
      style={{ backgroundColor: "#28a8df", borderColor: "#28a8df" }}
      onClick={() => {
        console.log("Confirming Map View for route:", pendingRoute);
        const areaToSet = pendingRoute?.DeliveryLocations[0];
        console.log("Setting map data:", areaToSet);
        setSelectedArea(areaToSet);
        setMapModal(true);
        setConfirmMapModal(false);
      }}
    >
      {isMapEdit ? "OK, Edit" : "OK, View"}
    </Button>
  </ModalFooter>
</Modal>
</>
  );
};

export default Route;